import z from 'zod';

import { MantineThemeColors } from '#core/lib/formatters/colors.ts';

export const IsoDateTime = z.iso.datetime({ offset: true }).describe('ISO 8601 datetime, e.g. "2024-01-15T10:30:00Z"');
export const SeriesColor = z.enum(MantineThemeColors);

export const StrokeStyle = z.enum(['solid', 'dashed', 'dotted']);
export const FillOpacity = z.enum(['none', 'light', 'medium', 'strong']);
export const ValueFormat = z.enum(['number', 'percent', 'currency', 'duration-ms', 'bytes']);
export const LegendPosition = z.enum(['top', 'bottom', 'right', 'hidden']);
export const GridMode = z.enum(['both', 'horizontal', 'vertical', 'none']);
export const GridSpan = z.number().int().min(1);

/** A literal value addressable on an axis. Strings for time/category, numbers for numeric. */
export const AxisValue = z
  .union([z.string(), z.number()])
  .describe(
    'Literal axis value for reference lines/areas. ' +
      'Time x-axis: ISO 8601 datetime string. Category x-axis: category label. Numeric axis: number.',
  );

// Axes

export const NumericAxis = z.object({
  label: z.string().optional(),
  scale: z.enum(['linear', 'log']).default('linear'),
  unit: z.string().optional().describe('Tick suffix, e.g. "ms", "%", "$".'),
  zeroReference: z.boolean().default(false).describe('When true, auto-computed range is expanded to include 0.'),
});

export const TimeAxis = z.object({
  label: z.string().optional(),
});

// Misc primitives

export const Threshold = z.object({
  value: z.number(),
  level: z.enum(['ok', 'warning', 'critical']),
  label: z.string().optional(),
});

export const ItemBase = z.object({
  id: z.string(),
  title: z.string(),
  description: z.string().optional(),
  gridSpan: GridSpan.default(1),
  datasets: z.any(),
});
